<script>
import { ref, computed, onMounted, nextTick} from 'vue'
import { useStore } from 'vuex'
import { useField } from 'vee-validate';
export default {
  name: "MenuSubMenu",
  setup(){
    const types = ['un particulier', 'un professionnel', 'un installeur chauffagiste'];
    const selects = ref(types);
    const store = useStore();
    const selectInput = ref('')
    const disclaimer= ref(false)

    const classes = computed(() => {
      return [ "menu-sub-menu", {
        open: store.state.navigation.main,
        "menu-sub-menu-disclaimer": disclaimer.value
      }];
    })

    function onChange() {
      window.dataLayer = window.dataLayer || [];
      const itemToPush = {
        'event': 'profile_select_change',
        'profile_select_val': selectInput.value,
        'event_location': 'header'
      }
      window.dataLayer.push(itemToPush);
    }
     onMounted(async () => {
      await nextTick();
      selectInput.value = document.querySelector('.el-select__input');
      if(window.location.pathname.includes('/pro/') || window.location.pathname === '/pro') {
        selectInput.value = 'Professionnel'
      } else if(window.location.pathname.includes('/prescripteur/') || window.location.pathname === '/prescripteur'){
        selectInput.value = 'Prescripteur'
      } else {
        selectInput.value = 'Particulier'
      }
      if(document.getElementsByClassName("menu-disclaimer").length > 0) {
        if(window.innerWidth < 960) {
          disclaimer.value = true
        }
      }
    })
    return {classes, onChange, selects, selectInput}
  }
}
</script>

<style lang="sass">
    @import ../../../common/styles/settings
    @import MenuSub
</style>
